var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMusicAdd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 164,
    height: 164,
    viewBox: "0 0 164 164",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;stroke:#000;}.b{clip-path:url(#a);}.c{stroke:none;}.d{fill:none;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47.168,
    height: 43.764,
    transform: "translate(0)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(17701 1777)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(-17701 -1777)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 164,
    height: 164,
    rx: 82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 0.5,
    y: 0.5,
    width: 163,
    height: 163,
    rx: 81.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-17619.457 -1726.973) rotate(45)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(-0.707 0.707)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.81,41.487A4.682,4.682,0,0,1,33.5,40.119L20.744,27.362,7.986,40.119A4.68,4.68,0,0,1,1.368,33.5L14.125,20.744,1.368,7.986A4.68,4.68,0,0,1,7.986,1.368L20.744,14.125,33.5,1.368a4.676,4.676,0,0,1,6.618,6.607L27.362,20.732,40.119,33.489a4.677,4.677,0,0,1-3.309,7.986",
    transform: "translate(3.29 1.587)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicAdd);
export default __webpack_public_path__ + "static/media/musicAdd.682fbd5e4e3cb8ac150b0d4b74d023fe.svg";
export { ForwardRef as ReactComponent };